<template>
  <div class="select-postal">
    <select-dropdown
      ref="postCodeSelect"
      :value="value"
      :placeholder="placeholder"
      label="PostalCode"
      :availableItems="availableItems"
      :is-load="isLoad"
      :required="required"
      :nothingText="nothingText"
      :tipsText="tipsText"
      :isPostal="isPostal"
      :error="error"
      @onSearch="$emit('onSearch', $event)"
      @selected="$emit('selected', $event)"
      @user-change-input="$emit('user-change-input', $event)"
      @clear="onClearPostal"
      @focusLost="$emit('focusLost', $event)"
      @error="$emit('error', $event)"
    />

    <input-postfix
      v-if="isPostalPostfix"
      class="select-postal__postfix"
      :value="valPostfix"
      @error="onErrorPostfix"
      @input="onInputPostfix"
    />
  </div>
</template>

<script>
import selectDropdown from '@/components/selectDropdown/selectDropdown.component.vue';
import inputPostfix from './input-postfix/input-postfix.component.vue';

export default {
  name: 'select-postal',
  components: {
    selectDropdown,
    inputPostfix,
  },
  props: {
    value: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: '',
    },
    availableItems: {
      type: Array,
      default: () => [],
    },
    isLoad: {
      type: Boolean,
      default: false,
    },
    tipsText: {
      type: String,
    },
    nothingText: {
      type: String,
    },
    error: {
      type: String,
    },
    loadText: {
      type: String,
    },
    debounce: {
      type: Number,
      default: 500,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    isPostal: {
      type: Boolean,
      default: false,
    },
    isPostalPostfix: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valPostfix() {
      const { Postfix } = this.value || {};
      return Postfix === 'XX' ? '' : Postfix;
    },
  },
  methods: {
    onClearClick() {
      this.$refs.postCodeSelect.onClearClick();
    },
    onClearPostal($event) {
      this.$emit('input-postfix', {
        ...this.value,
        Postfix: 'XX',
      });
      this.$emit('clear', $event);
    },
    onInputPostfix(value) {
      this.$emit('input-postfix', {
        ...this.value,
        Postfix: value,
      });
    },
    onErrorPostfix(isError) {
      this.$emit('error-postfix', isError);
    },
  },
};
</script>

<style scoped>
.select-postal {
  position: relative;
}

.select-postal__postfix {
  position: absolute;
  top: 17px;
  left: 50%;
  border: 0;
  margin: 0;
  background-color: transparent;
  outline: none;
  color: #111111;
  font-size: 18px;
  font-weight: 300;
  line-height: 2;
  letter-spacing: 4px;
  padding: 0;
  width: 35px;
}
</style>
